import React from 'react';
import InputLabelWide from '../common/InputLabelWide';
import LargeOutputLabel from '../common/LargeOutputLabel';

const formatTotal = (total) => total.toFixed(2);

const TotalRow = ({ formData = {}, currency }) => (
    <div className="grpDisp-form-total-row">
        <InputLabelWide text="Total Additional Spend" />
        <LargeOutputLabel
            text={`${currency}${formatTotal(formData.totalAdditionalSpend)}`}
            className="grpDisp-form-output-number-large"
        />
    </div>
);

export default TotalRow;
